import { all } from 'redux-saga/effects';
import deleteEle from './delete';
import getEle from './get';
import patchEle from './patch';
import postEle from './post';

export default all([deleteEle, getEle, patchEle, postEle]);
